import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { aiAgentDevelopmentConfig } from './servicePageConfigs';

const AiAgentDevelopment = () => <ServicePageTemplate {...aiAgentDevelopmentConfig} />;

export default AiAgentDevelopment;
